<template>
  <div class="heading-two">
    <h2 class="heading"><slot></slot></h2>
  </div>
</template>

<script>
export default {
  name: "HeadingTwo",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.heading-two {
  margin: 35px auto;
  @include mq-up(md) {
    margin: 50px auto;
  }
  &[class*="-border"] {
    text-align: center;
    > .heading {
      padding-bottom: 12px;
      display: inline-block;
    }
  }
  &.-border-green {
    > .heading {
      border-bottom: 2px solid $green;
    }
  }
  &.-border-orange {
    > .heading {
      border-bottom: 2px solid $orange;
    }
  }
  &.-border-blue {
    > .heading {
      border-bottom: 2px solid $blue;
    }
  }
  > .heading {
    color: #333;
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    @include mq-up(md) {
      font-size: 32px;
      line-height: 40px;
    }
  }
}
</style>
